module.exports = __webpack_public_path__ + "img/rrss2.fdd5b708.jpg";